import { IStorageFile } from '../interfaces/storageFile';
import { IPairUserFile } from '../interfaces/pairUserFile';
import { IPairUserRoleFile } from '../interfaces/pairUserRoleFile';
import { IPairContractFile } from '../interfaces/pairContractFile';
import { fillArray } from './_models.helper';
import { PairUserRoleFile } from './pairUserRoleFile';
import { PairContractFile } from './pairContractFile';
import { PairUserFile } from './pairUserFile';

export class StorageFile implements IStorageFile {
    id: number;
    contentType: string;
    sizeInBytes: number;
    absolutePath: string;
    alternativePath: string;
    description: string;
    filename: string;
    uploadDateTime: Date;
    idOwner: number;
    rUsersFiles: IPairUserFile[];
    rUsersRolesFiles: IPairUserRoleFile[];
    rCompleteContractFiles: IPairContractFile[];

    constructor(sf?: IStorageFile) {
        if (sf) {
            this.id = sf.id;
            this.contentType = sf.contentType;
            this.sizeInBytes = sf.sizeInBytes;
            this.absolutePath = sf.absolutePath;
            this.alternativePath = sf.alternativePath;
            this.description = sf.description;
            this.filename = sf.filename;
            this.uploadDateTime = new Date(sf.uploadDateTime);
            this.idOwner = sf.idOwner;
            this.rUsersFiles = fillArray(sf.rUsersFiles, PairUserFile);
            this.rUsersRolesFiles = fillArray(sf.rUsersRolesFiles, PairUserRoleFile);
            this.rCompleteContractFiles = fillArray(sf.rCompleteContractFiles, PairContractFile);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/storageFile.ts